<script>
  import { gql } from "@apollo/client/core";
  import { query } from "svelte-apollo";
  import * as Sentry from "@sentry/browser";

  import { client } from "apollo.js";
  import { languageInit } from "./i18n/language.js";
  import { colorShade } from "utils.js";

  import Notifications from "./notifications/Notifications.svelte";
  import Modal from "./components/Modal.svelte";
  import Loader from "./components/Loader.svelte";

  import { saveTheme, saveAccentColor, accentColor } from "stores.js";

  export let component;
  export let flow;

  languageInit();

  const ORGANIZATION_CONFIG_QUERY = gql`
    query OrganizationConfigQuery {
      organizationConfig {
        id
        name
        space
        logoHash
        logoWidth
        logoHeight
        theme
        accentColor
        clientBackgroundImage
        acceptedLanguages {
          tag
          quality
        }
      }
    }
  `;

  const theme = query(client, {
    query: ORGANIZATION_CONFIG_QUERY,
  });

  let root = document.documentElement;
  theme.result().then((r) => {
    Sentry.addBreadcrumb({
      category: "config",
      message: "Organization config: " + JSON.stringify(r),
      level: Sentry.Severity.Info,
    });

    const organizationConfig = r.data.organizationConfig;

    if (organizationConfig) {
      // TODO: set language
      //selectedLanguage = getLanguage(organizationConfig.acceptedLanguages);
      //setLanguage(selectedLanguage);

      if (organizationConfig.theme) {
        saveTheme(organizationConfig.theme);
      }

      if (organizationConfig.accentColor) {
        saveAccentColor(organizationConfig.accentColor);

        let lightAccentColor = colorShade($accentColor, 10);
        let darkAccentColor = colorShade($accentColor, -10);

        root.style.setProperty("--accent", $accentColor);
        root.style.setProperty("--accent-light", lightAccentColor);
        root.style.setProperty("--accent-dark", darkAccentColor);
      }

      if (organizationConfig.clientBackgroundImage) {
        root.style.setProperty(
          "--client-background-image",
          `url(${organizationConfig.clientBackgroundImage})`,
        );
      }
    }
  });

  // TODO: get language:
  // const getLanguage = acceptedLanguages => {
  //   const availableLanguages = ["en", "it"];
  //   const savedLanguage = localStorage.getItem("language");

  //   console.log("Saved Language:", savedLanguage);

  //   console.log("Accepted Languages:", acceptedLanguages);

  //   if (savedLanguage) {
  //     return savedLanguage;
  //   } else {
  //     const preferredLanguages = acceptedLanguages
  //       .filter(lang => availableLanguages.includes(lang.tag))
  //       .sort((a, b) => b.quality - a.quality);

  //     console.log("Preferred Languages:", preferredLanguages);

  //     return preferredLanguages.length > 0
  //       ? preferredLanguages[0].tag
  //       : defaultLanguage;
  //   }
  // };
</script>

<Notifications />
<Modal>
  {#await $theme}
    <div class="nolawyer">
      <Loader />
    </div>
  {:then config}
    {#if config.data.organizationConfig}
      <svelte:component
        this={component}
        {flow}
        config={config.data.organizationConfig}
        space={config.data.organizationConfig.space}
      />
    {:else}
      <p class="nolawyer">No space associated to {window.location.hostname}</p>
    {/if}
  {:catch error}
    <p>Error: {error}</p>
  {/await}
</Modal>

<style>
  :global(:root) {
    --blue-color: #1f363d;
    --seppia-color: #d0cbc4;
    --marine-color: #ab987a;
    --dark-marine-color: #675332;
    --gray-color: #5a5a5a;
    --dark-blue-color: #000422;

    --color-dark: #201e1e;
    --color-light: #fff;

    --light-hover: #e6e6e6;
    --light-dark: #ccc;

    --night: #1f363d;
    --night-light: #30545f;
    --night-dark: #0e181b;

    --accent: #c03549;
    --accent-light: #cd4a5d;
    --accent-dark: #a52e3f;

    --client-background-image: url(https://source.unsplash.com/GWe0dlVD9e0/1600x900);
  }

  :global(.vertical-nav) {
    display: block;
    margin: 0 -24px;
    padding: 16px 24px;
    border-left: 4px solid rgba(0, 0, 0, 0);
    font-size: 16px;
    cursor: pointer;
  }

  :global(.vertical-nav:hover) {
    border-left: 4px solid var(--accent);
  }

  :global(.vertical-nav.active) {
    font-weight: 700;
    border-left: 4px solid var(--accent);
  }

  :global(.tab) {
    color: var(--accent);
    border-top: 4px solid #eee;
    background-color: #eee;
    display: inline-block;
    padding: 12px 48px;
    cursor: pointer;
  }

  :global(.tab:hover) {
    background-color: #eee;
    color: black;
    border-top: 4px solid var(--accent);
  }

  :global(.tab.active) {
    background-color: white;
    color: black;
    border-top: 4px solid var(--accent);
  }

  .nolawyer {
    text-align: center;
    padding: 50px;
    font-size: 24px;
    letter-spacing: 0.08rem;
  }
</style>
